import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SideMenu.css';
import bt from '../../../components/commonStyle.css';
import {
  Button,
  Col,
  FormGroup
} from 'react-bootstrap';
import cx from 'classnames';

// Locale
import messages from '../../../locale/messages';


// Component 
import Link from '../../Link';
import history from '../../../core/history';

class SideMenu extends React.Component {
  static propTypes = {
    allUnreadThreadsCount: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getUnreadCount: PropTypes.shape({
        total: PropTypes.number.isRequired,
      }),
    }),
  };

  static defaultProps = {
    allUnreadThreadsCount: {
      loading: true,
      getUnreadCount: {
        total: 0,
      },
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      location: ''
    }
  }

  handleClick() {
    history.push('/become-a-host');
  }

  componentDidMount() {
    if (history.location) {
      this.setState({
        location: history.location.pathname
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (history.location) {
      this.setState({
        location: history.location.pathname
      });
    }
  }


  render() {
    const { allUnreadThreadsCount: { loading, getUnreadCount } } = this.props;
    let count = 0;
    if (!loading && getUnreadCount != null) {
      count = getUnreadCount.total != null ? getUnreadCount.total : 0;
    }
    const isNewMessage = count > 0;
    const { location } = this.state;
    //const { account: {accountType} } = this.props;
    
    return (
      <Col xs={12} sm={12} md={12} lg={4} className={s.space5}>
        <ul className={cx(s.listContainer, 'sideMenuBorder', 'listLayoutArbic')}>
          {/* <li className={cx('sideMenuBorderBottom', 'sideMenuBorderPadding', { ['menuActive']: location === "/inbox" })}>
            <Link to={"/inbox"} className={cx(s.sideNavitem, 'sideNav')}>
              <FormattedMessage {...messages.messages} />
              {
                isNewMessage && <FontAwesome.FaCircle className={s.notification} />
              }
            </Link>
          </li>
          <li className={cx('sideMenuBorderBottom', 'sideMenuBorderPadding', { ['menuActive']: location === "/rooms" })}>
            <Link to={'/rooms'} className={cx(s.sideNavitem, 'sideNav')}>
              <FormattedMessage {...messages.yourListings} />
            </Link>
          </li> */}
          <li className={cx('sideMenuBorderBottom', 'sideMenuBorderPadding', { ['menuActive']: location === "/reservation/current" })}>
            <Link to={'/reservation/current'} className={cx(s.sideNavitem, 'sideNav')}>
              <FormattedMessage {...messages.upcomingReservations} />
            </Link>
          </li>
          <li className={cx('sideMenuBorderBottom', 'sideMenuNoBorder', 'sideMenuBorderPadding', { ['menuActive']: location === "/reservation/previous" })}>
            <Link to={'/reservation/previous'} className={cx(s.sideNavitem, 'sideNav')}>
              <FormattedMessage {...messages.previousReservations} />
            </Link>
          </li>
          {/* <li className={cx('sideMenuBorderBottom', 'sideMenuBorderPadding', { ['menuActive']: location === "/trips/current" })}>
            <Link to={"/trips/current"} className={cx(s.sideNavitem, 'sideNav')} >
              <FormattedMessage {...messages.yourTrips} />
            </Link>
          </li>
          <li className={cx('sideMenuBorderBottom', 'sideMenuBorderPadding', { ['menuActive']: location === "/user/verification" })}>
            <Link to={"/user/verification"} className={cx(s.sideNavitem, 'sideNav')}>
              <FormattedMessage {...messages.trustAndVerification} />
            </Link>
          </li>
          <li className={cx('sideMenuBorderBottom', 'sideMenuBorderPadding', {
            ['menuActive']: location === "/user/edit" || location === "/user/photo"
              || location === "/user/verification" || location === "/user/reviews"
          })}>
            <Link to={"/user/edit"} className={cx(s.sideNavitem, 'sideNav')}>
              <FormattedMessage {...messages.profile} />
            </Link>
          </li>
          <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/user/payout" || location === "/user/transaction" || location === "/users/security" })}>
            <Link to={"/user/payout"} className={cx(s.sideNavitem, 'sideNav')}>
              <FormattedMessage {...messages.account} />
            </Link>
          </li> */}
        </ul>
        {/* <Col xs={12} sm={11} md={12} lg={7} className={cx(s.noPadding, s.space2, s.spaceTop2)} >
          <FormGroup className={s.formGroup}>
            <Button className={cx(s.button, bt.btnPrimary, s.sideMenuBtn)} onClick={this.handleClick}>
              <FormattedMessage {...messages.addListing} />
            </Button>
          </FormGroup>
        </Col> */}
      </Col>
    );
  }
}

export default withStyles(s, bt)(SideMenu);


// WEBPACK FOOTER //
// src/components/ManageListing/SideMenu/SideMenu.js